export { fetchHistoricalMetricPoints } from './metricPoints';
